define('TescoMobile_Checkout/js/view/monthly-payment-step',['jquery', 'ko', 'underscore', 'Magento_Ui/js/form/form', 'Magento_Checkout/js/model/quote', 'Magento_Checkout/js/model/step-navigator', '../action/set-monthly-payment', '../action/credit-check', '../action/get-available-bill-groups', '../action/get-kba-questions', '../action/validate-kba-answers', '../action/get-order-status', '../model/payment-information', 'Magento_Checkout/js/model/error-processor', 'uiRegistry', 'mage/translate', 'mage/template', 'Magento_Ui/js/modal/confirm', 'text!TescoMobile_Checkout/template/monthly-payment-modal-info.html', 'TescoMobile_Checkout/js/action/validate-order-identity', 'mage/url', 'Magento_Checkout/js/model/checkout-data-resolver', 'Magento_Checkout/js/checkout-data', 'Magento_Customer/js/model/customer', 'Magento_Customer/js/customer-data', 'moment', 'Magento_Checkout/js/model/full-screen-loader', '../model/cancelled-order-processor', '../model/create-callback-url', 'TescoMobile_Algolia/js/hooks'], function ($, ko, _, Component, quote, stepNavigator, setMonthlyPayment, creditCheck, getAvailableBillGroups, getKbaQuestions, validateKbaAnswers, getOrderStatus, paymentInformation, errorProcessor, registry, $t, mageTemplate, confirmModal, infoTmp, validateOrder, urlBuilder, checkoutDataResolver, checkoutData, customer, customerData, moment, fullScreenLoader, cancelledOrderProcessor, createCallbackUrl) {
  'use strict';

  const tescoConfig = window.checkoutConfig.tescomobile;
  const orderIdentityStatus = tescoConfig.order_identity_status;
  const workHourdData = tescoConfig.work_time;
  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/monthly_payment',
      visible: false,
      billGroups: [],
      availableText: 'Please call us on <a href="tel:%1">%1</a> so we can help you complete your order.',
      unavailableText: 'Please call us on <a href="tel:%1">%1</a> so we can confirm your details.',
      referenceOrderText: 'Your reference number is MAG-<span class="order-id">%1</span>',
      businessReferralText: 'Business customers please call',
      kbaFormSelector: '#co-kba-answers-form',
      kbaFormFieldsetSelector: '#co-kba-answers-form fieldset'
    },
    currentPaymentStep: 'payment',
    kbaQuestions: [],
    kbaSubmitDisabled: ko.observable(true),
    billGroup: ko.observable(null),
    infoContent: null,
    isLoading: false,
    backButtonVisible: false,
    isCustomerLoggedIn: customer.isLoggedIn,
    monthlyPayment: {},
    monthlyPaymentMethod: null,
    referenceOrderTextFormatted: null,
    referenceOrderAddressText: null,
    standardTime: $t('Mon-Fri: %1 - %2').replace('%1', workHourdData.standart_start.text).replace('%2', workHourdData.standart_end.text),
    satTime: $t('Sat: %1 - %2').replace('%1', workHourdData.sat_start.text).replace('%2', workHourdData.sat_end.text),
    sunTime: $t('Sun: %1 - %2').replace('%1', workHourdData.sun_start.text).replace('%2', workHourdData.sun_end.text),
    timeAvailable: ko.observable(true),
    referralsPhone: tescoConfig.referrals_phone,
    customerCarePhone: tescoConfig.customer_care_phone,
    businessCarePhone: tescoConfig.business_care_phone,
    customerTelesalesPhone: tescoConfig.customer_telesales_phone,
    businessSalesPhone: tescoConfig.business_sales_phone,
    customersReferralsPhone: tescoConfig.customers_referrals_phone,
    businessReferralsPhone: tescoConfig.business_referrals_phone,
    creditCheckDeclinedContent: tescoConfig.monthly_payment.credit_check_declined_content,
    creditCheckDeclinedMultiItemContent: tescoConfig.monthly_payment.credit_check_declined_multi_item_content,
    tmDirectDebitBillGroupIdUiElement: 'checkout.steps.monthly-payment-step.monthly-payment.monthly-payment-fieldset.tm_direct_debit_bill_group_id',
    tmDirectDebitBillGroupIdElementSelector: '.field[name="monthly-payment.tm_direct_debit_bill_group_id"]',
    copyReaded: true,
    isAssisted: false,
    responseCodeCallbackMapping: {
      'CO_280': paymentComponent => stepNavigator.next(),
      'CO_281': (paymentComponent, response) => {
        paymentInformation.ccaIframeUrl(createCallbackUrl.cca(response.payment_iframe_url));
        stepNavigator.next();
      },
      'CO_285': (paymentComponent, response) => {
        paymentComponent.creditCheckReferredScreen(response);
        paymentInformation.lockedSteps.push('monthly-payment');
      },
      'CO_185': paymentComponent => {
        paymentComponent.creditCheckDeclinedScreen();
        paymentInformation.lockedSteps.push('monthly-payment');
      },
      'CO_350': (paymentComponent, response) => {
        paymentInformation.paymentIframeUrl(createCallbackUrl.payment(response.payment_iframe_url));
        stepNavigator.next();
      }
    },
    initialize: function () {
      const self = this;
      this._super();
      stepNavigator.registerStep('monthly-payment', 'monthly-payment', $t('Your monthly payment'), this.visible, _.bind(this.navigate, this), this.sortOrder);
      this.monthlyPaymentMethod(quote.getData('customer_tm_monthly_payment_method') || 'NONE');
      if (this.monthlyPaymentMethod() === 'DD') {
        checkoutDataResolver.resolveMonthlyPaymentDirectDebit();
      } else if (this.monthlyPaymentMethod() === 'CARD') {
        checkoutDataResolver.resolveMonthlyPaymentCard();
      }
      registry.async('checkoutProvider')(function (checkoutProvider) {
        if (this.monthlyPaymentMethod() === 'DD') {
          const directDebit = checkoutData.getMonthlyPaymentDirectDebit();
          checkoutProvider.set('monthly-payment', $.extend(true, {}, checkoutProvider.get('monthly-payment'), directDebit));
          this.monthlyPayment({
            paymentDate: quote.getData('customer_tm_bill_group'),
            accountHolder: directDebit.tm_direct_debit_account_holder_name,
            sortCode: directDebit.tm_direct_debit_sort_code,
            accountNumber: directDebit.tm_direct_debit_account_number
          });
        } else if (this.monthlyPaymentMethod() === 'CARD') {
          const card = checkoutData.getMonthlyPaymentCard();
          const monthlyCardPayment = {
            paymentDate: quote.getData('customer_tm_bill_group'),
            cardType: card.card_type,
            cardNumber: $t('Card ending') + ' ' + card.card_number.replace(/\*/g, '')
          };
          if (card.expiry_date && card.expiry_date.split('+').length > 0) {
            try {
              const expiryDate = new Date(card.expiry_date.split('+')[0]);
              monthlyCardPayment.expiryDate = new Intl.DateTimeFormat('en-GB', {
                year: '2-digit',
                month: '2-digit'
              }).format(expiryDate);
            } catch (e) {
              monthlyCardPayment.expiryDate = '';
            }
          } else {
            monthlyCardPayment.expiryDate = '';
          }
          this.monthlyPayment(monthlyCardPayment);
        }
      }.bind(this));
      $(document).on('change', this.kbaFormSelector + ' input[type="radio"]', function () {
        this.kbaSubmitDisabled($(this.kbaFormFieldsetSelector).length !== $(this.kbaFormFieldsetSelector + ' input[type=radio]:checked').length);
      }.bind(this));
      $(document).on('change', this.tmDirectDebitBillGroupIdElementSelector + ' input[type="radio"]', function () {
        self.billGroup($(this).val());
        let selectedGroup = self.billGroups().filter(function (billGroup) {
          return billGroup.billGroupId === parseInt(self.billGroup());
        });
        if (selectedGroup.length > 0) {
          self.displayPreselectedDirectDebitBillDate(selectedGroup[0]);
        }
      });
      this.visible.subscribe(function (value) {
        if (value === true) {
          registry.async('checkoutProvider')(function () {
            this.populateOptionsIntoTmDirectDebitBillGroupElement();
          }.bind(this));
        } else {
          this.currentPaymentStep('payment');
        }
      }.bind(this));
    },
    initObservable: function () {
      return this._super().observe(['visible', 'currentPaymentStep', 'kbaQuestions', 'kbaSubmitDisabled', 'isLoading', 'backButtonVisible', 'infoContent', 'monthlyPayment', 'monthlyPaymentMethod', 'billGroups', 'referenceOrderAddressText', 'stepContent', 'copyReaded', 'referenceOrderTextFormatted']);
    },
    navigate: function (step) {
      const response = paymentInformation.response();
      step && step.isVisible(true);
      if ((response === null || response === void 0 ? void 0 : response.response_code) === 'CO_285') {
        this.creditCheckReferredScreen(response);
      } else if ((response === null || response === void 0 ? void 0 : response.response_code) === 'CO_185') {
        this.creditCheckDeclinedScreen(false);
      } else if ((response === null || response === void 0 ? void 0 : response.response_code) === 'CO_140') {
        stepNavigator.setHash('payment');
      } else if (['CO_141', 'CO_145'].includes(response === null || response === void 0 ? void 0 : response.response_code)) {
        cancelledOrderProcessor.setMessage(response);
      }
    },
    redirectToHomepage: function () {
      window.location.href = window.BASE_URL;
    },
    redirectToBasket: function () {
      window.location.href = window.checkoutConfig.cartUrl;
    },
    redirectToCardPayment: function () {
      this.currentPaymentStep('payment');
      stepNavigator.navigateTo('card-payment');
    },
    setKbaContent: function (content, contentType, hasVisibleButton) {
      this.currentPaymentStep(contentType);
      this.backButtonVisible(hasVisibleButton);
      this.infoContent(content);
      if (contentType === 'kbaError') {
        customerData.invalidate(['cart', 'tm-checkout-data', 'checkout-data']);
        paymentInformation.lockedSteps.push('monthly-payment');
      }
    },
    refreshPage: function () {
      const messageContainer = registry.get('checkout.errors').messageContainer;
      var error = {
        message: tescoConfig.pending_message
      };
      getOrderStatus().done(function (response) {
        if (response === 'CREDIT_CHECK_PASSED') {
          this.currentPaymentStep('refreshAfterCall');
        } else if (response === 'ORDER_CANCELLED') {
          this.creditCheckDeclinedScreen(false);
          paymentInformation.lockedSteps.push('monthly-payment');
        } else {
          messageContainer.addErrorMessage(error);
        }
      }.bind(this)).fail(function (response) {
        messageContainer.addErrorMessage(error);
      });
    },
    runCreditCheck: function () {
      const messageContainer = registry.get('checkout.errors').messageContainer;
      creditCheck(messageContainer).done(function (response) {
        if (this.responseCodeCallbackMapping[response.response_code]) {
          this.responseCodeCallbackMapping[response.response_code](this, response);
        } else if (['CO_141', 'CO_145'].includes(response.response_code)) {
          cancelledOrderProcessor.setMessage(response);
        } else if (response.response_code === 'CO_140') {
          paymentInformation.response(response);
          stepNavigator.setHash('payment');
        } else if (response.message) {
          messageContainer.addErrorMessage(response);
        }
      }.bind(this));
    },
    addCallbackToMapping: function (code, calback) {
      this.responseCodeCallbackMapping[code] = calback;
    },
    creditCheckReferredScreen: function (response) {
      var nowDay = new Date().toLocaleTimeString('en-us', {
          weekday: 'short'
        }).split(' ')[0].toLowerCase(),
        nowDayStartName = nowDay + '_start',
        nowDayEndName = nowDay + '_end',
        current = new Date().getHours();
      if (workHourdData.hasOwnProperty(nowDayStartName)) {
        var nowDayStart = workHourdData[nowDayStartName].value,
          nowDayEnd = workHourdData[nowDayEndName].value;
      } else {
        var nowDayStart = workHourdData['standart_start'].value,
          nowDayEnd = workHourdData['standart_end'].value;
      }
      if (response.hasOwnProperty('order_id') && response.order_id) {
        this.referenceOrderTextFormatted(this.referenceOrderText.replace('%1', response.order_id));
      }
      this.referenceOrderAddressText($t('<div class="opening-hours"><h5>Opening hours</h5><p class="support-text">%1<br>%2<br>%3</p>').replace('%1', this.standardTime).replace('%2', this.satTime).replace('%3', this.sunTime));
      this.currentPaymentStep('orderError');
      this.timeAvailable(current > nowDayStart && current < nowDayEnd);
      this.currentPaymentStep('orderError');
    },
    validateAnswers: function () {
      var form = $(this.kbaFormSelector),
        formData = form.serializeArray(),
        data = [],
        self = this;
      $.each(formData, function (i, input) {
        data.push({
          response_id: input.value,
          question_id: input.name.replace(/[^0-9\.]+/g, '')
        });
      });
      validateKbaAnswers(quote.getQuoteId(), data).done(function (response) {
        response = JSON.parse(response);
        if (response.status === 'PASS') {
          self.runCreditCheck();
        } else if (response.status === 'RETRY') {
          self.setKbaContent(response.error, 'kbaTimeout', true);
        } else {
          self.setKbaContent(response.error, 'kbaError', true);
          paymentInformation.lockedSteps.push('monthly-payment');
        }
      }).fail(function (response) {
        const error = this.processResponseError(response);
        self.setKbaContent(this.getErrorMessage(error), 'kbaError', true);
      }.bind(this));
    },
    getErrorMessage: function (error) {
      let content;
      if (error.error) {
        content = error.error;
      } else if (error.message) {
        content = error.message;
      } else {
        content = $t('Unexpected error occurred');
      }
      return content;
    },
    processResponseError: function (response) {
      let error;
      if (parseInt(response.status) === 401) {
        window.location.replace(urlBuilder.build('customer/account/login/'));
      } else {
        try {
          error = JSON.parse(response.responseText);
        } catch (exception) {
          error = {
            message: $t('Something went wrong with your request')
          };
        }
        return error;
      }
    },
    openInfoModal: function () {
      const portingTemplate = mageTemplate(infoTmp),
        infoData = _.extend({}, {
          content_modal: window.checkoutConfig.tescomobile.kba.main_content
        });
      $('body').trigger('dl-checkout-idv-disclaimer-show');
      confirmModal({
        title: $t('Just so you know'),
        content: portingTemplate({
          data: infoData
        }),
        type: 'slide',
        modalClass: 'monthly-payment-info-confirm-modal',
        buttons: [{
          text: $t('Continue'),
          class: 'action-primary action-accept kba-confirm-action',
          click: function (event) {
            this.closeModal(event, true);
          }
        }, {
          text: $.mage.__('Back'),
          class: 'action primary back kba-cancel-action hidden-for-online',
          click: function (event) {
            this.closeModal(event);
          }
        }],
        clickableOverlay: false,
        actions: {
          confirm: function () {
            validateOrder(quote.getQuoteId()).done(function (response) {
              response = JSON.parse(response);
              if (response.status === orderIdentityStatus.kba) {
                getKbaQuestions(quote.getQuoteId()).done(function (response) {
                  this.kbaQuestions(response);
                  this.currentPaymentStep('kba');
                  $('body').trigger('dl-checkout-kba-show');
                }.bind(this)).fail(function (response) {
                  const error = this.processResponseError(response);
                  this.setKbaContent(this.getErrorMessage(error), 'kbaError', true);
                }.bind(this));
              } else if (response.status === orderIdentityStatus.pass) {
                this.runCreditCheck();
              } else if (response.status === orderIdentityStatus.retry) {
                this.setKbaContent(response.error, 'kbaRetry', true);
              } else {
                this.setKbaContent(response.error, 'kbaError', true);
                paymentInformation.lockedSteps.push('monthly-payment');
              }
            }.bind(this)).fail(function (response) {
              $('body').trigger('dl-checkout-idv-failed-show');
              const error = this.processResponseError(response);
              this.setKbaContent(this.getErrorMessage(error), 'kbaError', true);
            }.bind(this));
          }.bind(this),
          cancel: function () {
            fullScreenLoader.stopLoader();
          }
        },
        opened: function () {
          if ($('#kba_checkbox').length > 0) {
            $('.kba-confirm-action').prop("disabled", true).addClass('disabled');
            $('.kba-cancel-action').removeClass('hidden-for-online');
            $('.monthly-payment-info-confirm-modal .modal-title').hide();
            $('body').on('change', '#kba_checkbox', function () {
              if (this.checked) {
                $('.kba-confirm-action').prop("disabled", false).removeClass('disabled');
              } else {
                $('.kba-confirm-action').prop("disabled", true).addClass('disabled');
              }
            });
          }
        }
      });
    },
    setMonthlyPayment: function () {
      $('body').trigger('dl-monthly-payment-notifications');
      if (customer.isLoggedIn() && this.monthlyPaymentMethod() !== 'NONE') {
        this.openInfoModal();
      } else {
        this.setSourceData();
        this.source.set('params.invalid', false);
        this.source.trigger('monthly-payment.data.validate');
        if (this.source.get('params.invalid')) {
          this.focusInvalid();
        } else {
          const monthlyPayment = this.source.get('monthly-payment');
          const payload = _.extend({}, monthlyPayment);
          const messageContainer = registry.get('checkout.errors').messageContainer;
          setMonthlyPayment(messageContainer, payload).done(function () {
            checkoutData.setMonthlyPaymentDirectDebit(monthlyPayment);
            this.openInfoModal();
          }.bind(this));
        }
      }
    },
    setSourceData: function () {
      const billNotificationType = $('input[name=tm_bill_preferred_notification]:checked').val();
      this.source.set('monthly-payment.tm_bill_preferred_notification', billNotificationType !== null && billNotificationType !== void 0 ? billNotificationType : '');
      this.source.set('monthly-payment.tm_direct_debit_bill_group_id', this.billGroup());
    },
    creditCheckDeclinedScreen: function () {
      let showSimoDeals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      customerData.invalidate(['cart', 'tm-checkout-data', 'checkout-data']);
      this.currentPaymentStep('creditCheckDeclined');
      if (showSimoDeals && !this.isMultiItemBasket()) {
        algolia.searchAlternativeDeals('#credit-check-declined-alternative-deals', 'SIMO', []);
      }
      $('body').trigger('dl-checkout-idv-failed-show');
    },
    isMultiItemBasket: function () {
      return quote.getItems().length > 1;
    },
    populateOptionsIntoTmDirectDebitBillGroupElement: function () {
      const tmDirectDebitBillGroupElement = registry.get(this.tmDirectDebitBillGroupIdUiElement);
      getAvailableBillGroups().done(function (availableBillGroupsJson) {
        let availableBillGroups = JSON.parse(availableBillGroupsJson);
        availableBillGroups.sort((a, b) => a.paymentCollectionDay > b.paymentCollectionDay && 1 || -1);
        this.billGroups(availableBillGroups);
        tmDirectDebitBillGroupElement.setOptions(availableBillGroups.map((billGroup, index) => ({
          value: billGroup.billGroupId,
          label: moment.localeData().ordinal(billGroup.paymentCollectionDay)
        })));
        let preselectedBillGroup = $.grep(availableBillGroups, function (billGroup) {
          return billGroup.selected === true;
        });
        if (this.source.get('monthly-payment.tm_direct_debit_bill_group_id')) {
          preselectedBillGroup = availableBillGroups.filter(function (billGroup) {
            return billGroup.billGroupId === this.source.get('monthly-payment.tm_direct_debit_bill_group_id');
          }.bind(this));
        }
        $(this.tmDirectDebitBillGroupIdElementSelector + ' input[value="' + preselectedBillGroup[0].billGroupId + '"]').prop('checked', true);
        this.billGroup(preselectedBillGroup[0].billGroupId);
        this.moveDirectDebitMonthlyPaymentDateDropdown();
        this.displayPreselectedDirectDebitBillDate(preselectedBillGroup[0]);
        $('.monthly-payment-preselected-first-direct-debit-date').html(preselectedBillGroup[0].preselectedPaymentCollectionDayMonth);
      }.bind(this));
    },
    moveDirectDebitMonthlyPaymentDateDropdown: function () {
      $(this.tmDirectDebitBillGroupIdElementSelector).find('.label').remove();
      $('.tm-direct-debit-bill-group-id-dropdown').html($(this.tmDirectDebitBillGroupIdElementSelector).remove());
    },
    displayPreselectedDirectDebitBillDate: function (BillGroup) {
      $('.monthly-payment-first-direct-debit-date').html(BillGroup.preselectedPaymentCollectionDayMonth);
    },
    getAvailableTextFormatted: function () {
      return $t(this.availableText).replace(/%1/g, tescoConfig.referrals_phone);
    },
    getUnavailableTextFormatted: function () {
      return $t(this.unavailableText).replace(/%1/g, tescoConfig.referrals_phone);
    }
  });
});

